import React from 'react';
import { Responsive, WidthProvider, Layouts } from 'react-grid-layout';
import './WellSummaryWidget.scss';
import { TopWidgetKey, WellSummaryKey } from '../../../../types/GLDashboardTypes';
import { formatNumber } from '../../../../utilities/Helpers';

const ResponsiveGridLayout = WidthProvider(Responsive);

const data = [
  { key: TopWidgetKey.WellsEnabled, title: 'Total number of wells', color: '#00A17B' },
  { key: TopWidgetKey.WellsRunning, title: 'Active wells', color: '#00A17B' },
  { key: TopWidgetKey.WellsNoTests, title: 'Wells with no test data', color: '#C78500' },
  { key: TopWidgetKey.CountHighDaysSinceTested, title: 'Wells with test >%count days', color: '#F04438' }, // change key as per response
  { key: TopWidgetKey.WellsOutOfService, title: 'Wells out of service', color: '#384252' },
];
interface WellSummaryProps {
  count?: Record<WellSummaryKey, number>;
  HighDaysSinceTested?: number;
  isEspDashboard?: boolean;
  espDegradationWellsAffected?: number;
}
const WellSummaryWidget: React.FC<WellSummaryProps> = ({
  count,
  HighDaysSinceTested,
  isEspDashboard,
  espDegradationWellsAffected,
}: WellSummaryProps) => {
  const layouts: Layouts = {
    lg: [
      { i: TopWidgetKey.WellsEnabled, x: 0, y: 0, w: 1, h: 1 },
      { i: TopWidgetKey.WellsRunning, x: 1, y: 0, w: 1, h: 1 },
      { i: TopWidgetKey.WellsNoTests, x: 2, y: 0, w: 1, h: 1 },
      { i: TopWidgetKey.CountHighDaysSinceTested, x: 3, y: 0, w: 1, h: 1 },
      { i: TopWidgetKey.WellsOutOfService, x: 4, y: 0, w: 1, h: 1 },
    ],
    md: [
      { i: TopWidgetKey.WellsEnabled, x: 0, y: 0, w: 1, h: 1 },
      { i: TopWidgetKey.WellsRunning, x: 1, y: 0, w: 1, h: 1 },
      { i: TopWidgetKey.WellsNoTests, x: 2, y: 0, w: 1, h: 1 },
      { i: TopWidgetKey.CountHighDaysSinceTested, x: 3, y: 0, w: 1, h: 1 },
      { i: TopWidgetKey.WellsOutOfService, x: 4, y: 0, w: 1, h: 1 },
    ],
    sm: [
      { i: TopWidgetKey.WellsEnabled, x: 0, y: 0, w: 2, h: 1 },
      { i: TopWidgetKey.WellsRunning, x: 2, y: 0, w: 2, h: 1 },
      { i: TopWidgetKey.WellsNoTests, x: 4, y: 0, w: 2, h: 1 },
      { i: TopWidgetKey.CountHighDaysSinceTested, x: 0, y: 1, w: 3, h: 1 },
      { i: TopWidgetKey.WellsOutOfService, x: 3, y: 1, w: 3, h: 1 },
    ],
  };

  return (
    <ResponsiveGridLayout
      className='well-summary-container'
      layouts={layouts}
      breakpoints={{ lg: 1220, md: 820, sm: 686 }}
      cols={{ lg: 5, md: 5, sm: 6 }}
      rowHeight={105}
      isDraggable={false}
      isResizable={false}
      margin={[20, 16]}
    >
      {data.map((item) => (
        <div className='well-summary__item' key={item.key} style={{ background: item.color }}>
          <span className='count'>
            {item.key === TopWidgetKey.WellsOutOfService && isEspDashboard
              ? formatNumber(count?.[item.key as WellSummaryKey] || 0, 0) || 0
              : count?.[item.key as WellSummaryKey] || 0}
          </span>
          <br />
          {item.key === TopWidgetKey.CountHighDaysSinceTested
            ? item.title.replace('%count', isEspDashboard ? '30' : HighDaysSinceTested?.toString() || '-')
            : item.key === TopWidgetKey.WellsOutOfService && isEspDashboard
              ? `Lost oil from ${espDegradationWellsAffected?.toString() || '0'} wells`
              : item.title}
        </div>
      ))}
    </ResponsiveGridLayout>
  );
};
export default WellSummaryWidget;
